import { TILE_H, TILE_W } from "@vinyl/shared";

export interface ScreenPos {
  sx: number;
  sy: number;
}

export interface FractionalTile {
  tx: number;
  ty: number;
}

export function tileToScreen(tx: number, ty: number): ScreenPos {
  return {
    sx: (tx - ty) * (TILE_W / 2),
    sy: (tx + ty) * (TILE_H / 2),
  };
}

export function screenToTileFloat(sx: number, sy: number): FractionalTile {
  const a = sx / (TILE_W / 2);
  const b = sy / (TILE_H / 2);
  return { tx: (a + b) / 2, ty: (b - a) / 2 };
}

export function pixelToTile(sx: number, sy: number): { tx: number; ty: number } {
  const f = screenToTileFloat(sx, sy);
  return { tx: Math.round(f.tx), ty: Math.round(f.ty) };
}
